import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../mock";
import { useMedia, resolveUrl } from "../context/MediaContext";
import PageHero from "../components/PageHero";
import { EASE } from "../lib/motion";

export default function TestimonialsPage() {
  const { slots } = useMedia();
  return (
    <div className="bg-[#F7F2E9] min-h-screen">
      <PageHero
        eyebrow="Guest Stories"
        title="What Guests"
        accent="Say"
        image={resolveUrl(slots.poolSpa)}
        subtitle="We love creating memorable stays. Here's what guests share about The Jackson House."
      />

      <div className="max-w-[1200px] mx-auto px-6 py-24">
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, ease: EASE, delay: (i % 3) * 0.1 }}
              className="mb-6 break-inside-avoid rounded-[24px] bg-white/60 border border-white/70 p-8 shadow-[0_15px_40px_rgba(10,59,46,0.07)] relative"
            >
              <Quote className="text-[var(--moss)]/15 absolute top-6 right-6" size={44} />
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, s) => (
                  <Star key={s} size={17} className="fill-[var(--gold)] text-[var(--gold)]" />
                ))}
              </div>
              <p className="font-display italic text-[#0A3B2E] text-lg leading-relaxed">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3 mt-6">
                <div className="w-11 h-11 rounded-full bg-[#0A3B2E] text-[#F7F2E9] grid place-items-center font-display font-bold">{t.name.charAt(0)}</div>
                <div>
                  <p className="font-body font-bold text-[#0A3B2E]">{t.name}</p>
                  <p className="text-sm text-[#16241E]/50">{t.location}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
